module.exports = "<iframe \n    title=\"Maj des partenaires\"\n    width=\"100%\"\n    height=\"700px\"\n    [src]=\"adress\">\n</iframe>"